<template>
  <v-app :theme="isDarkMode ? 'dark' : 'light'">
    <v-main style="background: transparent !important;">
      <v-container class="mt-16" fluid>
        <!-- Switch para cambiar entre Light/Dark Mode -->
        <!--<v-row>
          <v-col>
            <v-switch
                v-model="isDarkMode"
                label="Modo Oscuro"
                inset
                color="primary"
            ></v-switch>
          </v-col>
        </v-row>-->

        <v-row justify="center">
          <!-- Contenedor de Inputs -->
          <v-col cols="12" md="6" class="col-style">
            <v-row>
              <v-alert
                  color="error"
                  icon="$error"
                  title="Usa solo números."
                  text="Todos los campos deben tener información."
                  v-if="validationError"
              >
              </v-alert>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Inversión Inicial</v-label>
                <v-text-field
                    type="number"
                    v-model.number="amount"
                    :prefix="currency"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                    class="bg-custom"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Contribuciones</v-label>
                <v-text-field
                    type="number"
                    v-model.number="payment"
                    :prefix="currency"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Frecuencia</v-label>
                <v-select
                    v-model="frequencyOption"
                    :items="itemsFreq"
                    item-title="state"
                    item-value="valorFreq"
                    return-object
                    variant="outlined"
                    density="compact"
                ></v-select>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Retorno Esperado</v-label>
                <v-text-field
                    type="number"
                    v-model.number="retorno"
                    :prefix="percent"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="pa-0 ma-0">
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Compounding</v-label>
                <v-select
                    v-model="compoundingOption"
                    :items="itemsComp"
                    item-title="state"
                    item-value="valorComp"
                    return-object
                    variant="outlined"
                    density="compact"
                ></v-select>
              </v-col>
              <v-col cols="6" class="col-style">
                <v-label class="custom-label">Años</v-label>
                <v-text-field
                    type="number"
                    v-model.number="years"
                    variant="outlined"
                    density="compact"
                    @input="onChange($event)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>


          <!-- Contenedor de Resultados -->
          <!-- Sección de resultados -->
          <v-col cols="12" md="6" class="col-style">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" class="col-style">
                <div class="results-container">
                  <div class="result-item">
                    <span class="result-label">Balance Final</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(result) }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Inversión Total</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(inversion) }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Contribuciones</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(contribuciones) }}</span>
                  </div>
                  <div class="result-item">
                    <span class="result-label">Ganancia</span>
                    <span class="result-value">{{ currency }}{{ formattedNumber(interes) }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <hr class="my-12">
        <v-row>

          <v-row>
            <v-col cols="12">
              <h1 class="title-pie"> Crecimiento Anual </h1>
              <v-divider class="monthly-payment-line"></v-divider>
              <div id="barchart-div" style="width: 100%; height: 500px;"></div>
            </v-col>
          </v-row>
        </v-row>
        <hr class="my-12">
        <v-row class="mt-12 d-flex justify-center">
          <v-col cols="12" md="6">
            <div>
              <h1 class="title-pie"> Primer Año </h1>
              <v-divider class="monthly-payment-line"></v-divider>
              <div id="chartdiv" style="width: 100%; height: 400px;"></div>
            </div>
          </v-col>
          <v-col cols="12" class="d-lg-none my-12">
            <hr>
          </v-col>
          <v-col cols="12" md="6">
            <h1 class="title-pie"> Balance Final </h1>
            <v-divider class="monthly-payment-line"></v-divider>
            <div id="chartdivlast" style="width: 100%; height: 400px;"></div>
          </v-col>
        </v-row>
        <hr class="my-12">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs class="tab-text" v-model="tab" >
                <v-tab value="anualizado">Crecimiento Anualizado</v-tab>
                <v-tab value="mensual">Tabla {{ frequencyOption.state }}</v-tab>
              </v-tabs>
              <v-card-text>
                <v-window v-model="tab">
                  <v-window-item value="anualizado">
                    <v-table fixed-header class="w-100" height="580px">
                      <thead>
                      <tr>
                        <th class="text-left">Año</th>
                        <th class="text-left">Principal</th>
                        <th class="text-left">Ganancia</th>
                        <th class="text-left">Ganancia Total</th>
                        <th class="text-left">Balance Final</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in tablaAnualizada" :key="item.name">
                        <td>{{ item.year }}</td>
                        <td>{{ formattedNumber(item.balance) }}</td>
                        <td>{{ formattedNumber(item.total) }}</td>
                        <td>{{ formattedNumber(item.ganancia) }}</td>
                        <td>{{ formattedNumber(item.finalBalance) }}</td>
                      </tr>
                      </tbody>
                    </v-table>
                  </v-window-item>
                  <v-window-item value="mensual">
                    <v-table fixed-header class="w-100" height="580px">
                      <thead>
                      <tr>
                        <th class="text-left">{{ frequencyOption.freq }}</th>
                        <th class="text-left">Principal</th>
                        <th class="text-left">Ganancia</th>
                        <th class="text-left">Ganancia Total</th>
                        <th class="text-left">Balance Final</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="item in tablaMensual" :key="item.name">
                        <td>{{ item.mes }}</td>
                        <td>{{ formattedNumber(item.balance) }}</td>
                        <td>{{ formattedNumber(item.ganancia) }}</td>
                        <td>{{ formattedNumber(item.total) }}</td>
                        <td>{{ formattedNumber(item.finalBalance) }}</td>
                      </tr>
                      </tbody>
                    </v-table>
                  </v-window-item>
                </v-window>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: 'App',
  data() {
    return {
      isDarkMode: false, // Estado inicial para el modo oscuro
      language: "es",
      percent: "%",
      currency: "$",
      frequency: 0,
      compounding: 0,
      frequencyOption: {state: 'Mensual', valorFreq: 12, freq: 'Mes'},
      itemsFreq: [
        {state: 'Anual', valorFreq: 1, freq: 'Año'},
        {state: 'Semestral', valorFreq: 2, freq: 'Semestre'},
        {state: 'Trimestral', valorFreq: 4, freq: 'Trimestre'},
        {state: 'Mensual', valorFreq: 12, freq: 'Mes'},
        {state: 'Quincenal', valorFreq: 26, freq: 'Quincena'},
        {state: 'Semanal', valorFreq: 52, freq: 'Semana'},
        {state: 'Diario', valorFreq: 365, freq: 'Dia'},
      ],
      compoundingOption: {state: 'Anual', valorComp: 1},
      itemsComp: [
        {state: 'Anual', valorComp: 1},
        {state: 'Semestral', valorComp: 2},
        {state: 'Trimestral', valorComp: 4},
        {state: 'Mensual', valorComp: 12},
        {state: 'Quincenal', valorComp: 26},
        {state: 'Semanal', valorComp: 52},
        {state: 'Diario', valorComp: 365},
      ],
      tab: null,
      piechart: null,
      amount: 0,
      payment: 0,
      retorno: 0,
      years: 0,
      result: 0,
      contribuciones: 0,
      contribucionpie: 0,
      interes: 0,
      inversion: 0,
      validationError: false,
      balanceInicial: 0,
      balancePrincipal: 0,
      balanceFinal: 0,
      totalTabla: 0,
      interesTotal: 0,
      interesTabla: 0,
      gananciaAnualizada: 0,
      gananciaAnualizadaLast: 0,
      interesTablaFirst: 0,
      tablaAnual: [],
      tablaMensual: [],
      tablaAnualizada: [],
      chartData: [],
      chart: null,
      chartLast: null,
      chartBarData: [],
    };
  },
  watch: {
    frequencyOption: function () {
      this.onChange();
    },
    compoundingOption: function () {
      this.onChange();
    },
    isDarkMode(newValue) {
      this.updateChartTheme(newValue);
    }
  },
  components: {
    //Search
  },
  methods: {
    onChange() {
      if (
          this.amount !== '' &&
          this.payment !== '' &&
          this.retorno !== '' &&
          this.years > 0
      ) {
        this.validationError = false
        this.calculate();
      } else {
        this.validationError = false
      }
    },
    calculate() {
      const currentDate = new Date();
      let actYear = currentDate.getFullYear();
      const frequency = parseFloat(this.frequencyOption.valorFreq);
      const compounding = parseFloat(this.compoundingOption.valorComp);
      const retornoFixed = this.retorno / 100;
      const rate = Math.pow((1 + retornoFixed / compounding), (compounding / frequency)) - 1;
      const nper = frequency * this.years;
      const contribucionpie = this.payment * frequency;
      this.contribuciones = this.payment * nper;
      this.result = rate === 0 ? 0 : (this.amount * Math.pow((1 + rate), nper) + this.payment * ((Math.pow((1 + rate), nper) - 1) / rate)).toFixed(2).toLocaleString();
      this.interes = this.result === 0 ? 0 : (this.result - this.amount - this.contribuciones).toFixed(2).toLocaleString();
      this.inversion = this.contribuciones + this.amount;
      this.balancePrincipal = this.amount + this.payment;
      let balanceTotal = this.balancePrincipal;

      //Calcular Tabla Anual
      const yearsQuantity = this.years;
      let balanceInicial = this.amount;
      let totalTabla = this.amount * Math.pow(1 + Math.pow((1 + retornoFixed / compounding), (compounding)) - 1, 1);
      let interesTabla = totalTabla - balanceInicial;
      let balanceFinal = totalTabla + (this.payment * nper / this.years);
      this.tablaAnual = [];
      this.tablaAnual.push({
        year: 1,
        balance: balanceInicial.toFixed(2),
        ganancia: interesTabla.toFixed(2),
        total: totalTabla.toFixed(2),
        finalBalance: balanceFinal.toFixed(2)
      });

      for (let index = 2; index <= yearsQuantity; index++) {
        balanceInicial = balanceFinal;
        totalTabla = balanceInicial * Math.pow(1 + Math.pow((1 + retornoFixed / compounding), (compounding)) - 1, 1);
        interesTabla = totalTabla - balanceInicial;
        balanceFinal = totalTabla + (this.payment * nper / this.years);
        this.tablaAnual.push({
          year: index,
          balance: balanceInicial.toFixed(2),
          ganancia: interesTabla.toFixed(2),
          total: totalTabla.toFixed(2),
          finalBalance: balanceFinal.toFixed(2)
        });
        //PIE LAST
        if (index === yearsQuantity) {
          this.chartLast.data = [{
            "categoria": "Ganancia Total",
            "valor": interesTabla.toFixed(2),
            "color": "#659F6B",
          },
            {
              "categoria": "Inversión Inicial",
              "valor": this.amount.toFixed(2),
              "color": "#123B4F",
            },
            {
              "categoria": "Contribuciones",
              "valor": (this.payment * nper).toFixed(2),
              "color": "#E6AE3F",
            }];
        }
      }

      //Calcular Tabla por Frecuencia
      const monthQuantity = this.years * frequency;
      let frequencyCounter = 1;
      let yearsCounter = 0;

      let graficaStartInit = 0;
      let interesTotal = 0;

      let interesTablaFirst = 0;
      let acumuladoGanancia = 0;

      this.tablaMensual = [];
      this.tablaAnualizada = [];
      this.chartBarData = [];

      for (let index = 1; index <= monthQuantity; index++) {
        if (index === 1) {
          balanceInicial = this.amount;
          totalTabla = this.amount * Math.pow(1 + Math.pow((1 + retornoFixed / compounding), (compounding / frequency)) - 1, 1);
          interesTabla = totalTabla - balanceInicial;
          interesTotal = interesTabla;
          balanceTotal = balanceInicial + this.payment;
        } else {
          balanceTotal = balanceTotal + this.payment;
          balanceInicial = balanceFinal;
          totalTabla = balanceInicial * Math.pow(1 + Math.pow((1 + retornoFixed / compounding), (compounding / frequency)) - 1, 1);
          interesTabla = totalTabla - balanceInicial;
          interesTotal = interesTotal + interesTabla;
        }
        balanceFinal = totalTabla + (this.payment * nper / this.years / frequency);

        acumuladoGanancia += interesTabla;

        this.tablaMensual.push({
          mes: index,
          balance: balanceTotal.toFixed(2),
          ganancia: interesTabla.toFixed(2),
          total: interesTotal.toFixed(2),
          finalBalance: balanceFinal.toFixed(2)
        });
        if (frequencyCounter === frequency) {
          yearsCounter++;
          this.tablaAnualizada.push({
            year: yearsCounter,
            balance: balanceTotal.toFixed(2),
            ganancia: interesTotal.toFixed(2),
            total: acumuladoGanancia.toFixed(2),
            finalBalance: balanceFinal.toFixed(2)
          })
          //BARRA CALC
          this.chartBarData.push({
            "date": actYear.toString(),
            "principal": balanceTotal.toFixed(2),
            "ganancia": acumuladoGanancia.toFixed(2),
            "ganancia_total": interesTotal.toFixed(2),
            "total": balanceFinal.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD', // Cambia a tu moneda deseada (ejemplo: 'EUR', 'JPY', 'GBP', etc.)
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          });
          acumuladoGanancia = 0;
          actYear++;
          //BARRA CALC
          frequencyCounter = 0;
        }

        frequencyCounter++;
      }

      this.chartBar.data = this.chartBarData;

      interesTablaFirst = this.tablaAnualizada[0].ganancia;
      graficaStartInit = interesTotal;

      this.chart.data = [{
        "categoria": "Ganancia Total",
        "valor": interesTablaFirst,
        "color": "#659F6B",
      },
        {
          "categoria": "Inversión Inicial",
          "valor": this.amount.toFixed(2),
          "color": "#123B4F",
        },
        {
          "categoria": "Contribuciones",
          "valor": contribucionpie.toFixed(2),
          "color": "#1D5F80",
        }];

      this.chartLast.data = [{
        "categoria": "Ganancia Total",
        "valor": graficaStartInit.toFixed(2),
        "color": "#659F6B",
      },
        {
          "categoria": "Inversión Inicial",
          "valor": this.amount.toFixed(2),
          "color": "#123B4F",
        },
        {
          "categoria": "Contribuciones",
          "valor": (this.payment * nper).toFixed(2),
          "color": "#1D5F80",
        }];
    },
    updateChartTheme(isDark) {
      const textColor = isDark ? "#7c7c7c" : "#7c7c7c"; // Blanco en dark mode, negro en light mode

      // PieChart principal
      if (this.chart) {
        this.chart.legend.labels.template.fill = am4core.color(textColor);
        this.chart.legend.valueLabels.template.fill = am4core.color(textColor);

        this.chart.series.each(series => {
          series.labels.template.fill = am4core.color(textColor);
          series.ticks.template.stroke = am4core.color(textColor); // Color de las líneas que conectan las etiquetas
        });
      }

      // PieChart del último balance
      if (this.chartLast) {
        this.chartLast.legend.labels.template.fill = am4core.color(textColor);
        this.chartLast.legend.valueLabels.template.fill = am4core.color(textColor);

        this.chartLast.series.each(series => {
          series.labels.template.fill = am4core.color(textColor);
          series.ticks.template.stroke = am4core.color(textColor);
        });
      }

      // BarChart
      if (this.chartBar) {
        this.chartBar.xAxes.each(axis => {
          axis.renderer.labels.template.fill = am4core.color(textColor);
          axis.title.fill = am4core.color(textColor);
        });

        this.chartBar.yAxes.each(axis => {
          axis.renderer.labels.template.fill = am4core.color(textColor);
          axis.title.fill = am4core.color(textColor);
        });

        this.chartBar.legend.labels.template.fill = am4core.color(textColor);
        this.chartBar.legend.valueLabels.template.fill = am4core.color(textColor);
      }
    },
    formattedNumber(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.isDarkMode = urlParams.get("theme") === "dark";
    this.language = urlParams.get("lang") || "es";

    console.log("Modo Oscuro:", this.isDarkMode);
    console.log("Idioma:", this.language);


    /*const targetNode = document.documentElement || document.body; // Observa HTML si Body no funciona

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const isLightMode = targetNode.classList.contains("pix-is-light");
          this.isDarkMode = !isLightMode; // Si no está "pix-is-light", es dark mode
          this.updateChartTheme(this.isDarkMode);
          console.log("Modo oscuro actualizado:", this.isDarkMode ? "Dark" : "Light");
        }
      });
    });

    observer.observe(targetNode, { attributes: true });

    // Inicializar el estado según la clase actual
    this.isDarkMode = !targetNode.classList.contains("pix-is-light");*/


    this.chart = am4core.create("chartdiv", am4charts.PieChart);
    if (this.chart.logo) {
      this.chart.logo.dispose()
    }
    this.chart.data = [{
      "categoria": "Ganancia Total",
      "valor": 0,
      "color": "#659F6B",
    },
      {
        "categoria": "Inversión Inicial",
        "valor": 0,
        "color": "#123B4F",
      },
      {
        "categoria": "Contribuciones",
        "valor": 0,
        "color": "#1D5F80",
      }];
    let pieSeries = this.chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "valor";
    pieSeries.dataFields.category = "categoria";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.labels.template.text = "{value.percent.formatNumber('#.00')}%";
    pieSeries.slices.template.tooltipText = "[bold, font-size:35px]${valor.formatNumber('#,###.##')}\n[normal]{categoria}[/]";
    pieSeries.slices.template.tooltipX = 0;
    pieSeries.slices.template.tooltipY = 40;
    pieSeries.tooltip.label.textAlign = "middle";
    pieSeries.tooltip.background.filters.clear();
    pieSeries.tooltip.background.pointerLength = 0;
    pieSeries.tooltip.background.strokeOpacity = 0;
    pieSeries.tooltip.label.propertyFields.fill = "color";
    pieSeries.tooltip.background.cornerRadius = 50;
    pieSeries.tooltip.label.minWidth = 150;
    pieSeries.tooltip.label.minHeight = 100;
    pieSeries.tooltip.label.textValign = "middle";
    let hs = pieSeries.slices.template.states.getKey("hover");
    hs.properties.scale = 1.08;
    let as = pieSeries.slices.template.states.getKey("active");
    as.properties.shiftRadius = .1;
    this.chart.data.reverse();
    // LEYENDA
    this.chart.legend = new am4charts.Legend();
    this.chart.legend.labels.template.fill = am4core.color("#7c7c7c");
    this.chart.legend.valueLabels.template.fill = am4core.color("#7c7c7c");
    this.chart.legend.valueLabels.template.text = "";
    let marker = this.chart.legend.markers.template.children.getIndex(0);
    marker.cornerRadius(15, 15, 15, 15);
    marker.strokeWidth = 2;
    marker.strokeOpacity = 1;
    // ANIAMCION INICIAL
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;

    // RESPONSIVE
    this.chart.responsive.enabled = true;
    this.chart.responsive.rules.push({
      relevant: function (target) {
        return target.pixelWidth <= 500;
      },
      state: function (target, stateId) {
        if (target instanceof am4charts.PieSeries) {
          const state = target.states.create(stateId);
          state.properties.paddingTop = 0;
          state.properties.paddingRight = 0;
          state.properties.paddingBottom = 0;
          state.properties.paddingLeft = 0;

          const labelState = target.labels.template.states.create(stateId);
          labelState.properties.disabled = true;

          const tickState = target.ticks.template.states.create(stateId);
          tickState.properties.disabled = true;
          return state;
        }
        return null;
      }
    });
    //ChartPieLastYear
    this.chartLast = am4core.create("chartdivlast", am4charts.PieChart);
    if (this.chartLast.logo) {
      this.chartLast.logo.dispose()
    }
    this.chartLast.data = [{
      "categoria": "Ganancia Total",
      "valor": 0,
      "color": "#659F6B",
    },
      {
        "categoria": "Balance",
        "valor": 0,
        "color": "#123B4F",
      },
      {
        "categoria": "Contribuciones",
        "valor": 0,
        "color": "#1D5F80",
      }];
    let pieSeriesLast = this.chartLast.series.push(new am4charts.PieSeries());
    pieSeriesLast.dataFields.value = "valor";
    pieSeriesLast.dataFields.category = "categoria";
    pieSeriesLast.slices.template.tooltipText = "{categoria}\n[bold]${valor}[/]";
    pieSeriesLast.slices.template.propertyFields.fill = "color";
    pieSeriesLast.labels.template.text = "{value.percent.formatNumber('#.00')}%";
    pieSeriesLast.slices.template.tooltipText = "[bold, font-size:35px]${valor.formatNumber('#,###.##')}\n[normal]{categoria}[/]";
    pieSeriesLast.slices.template.tooltipX = 0;
    pieSeriesLast.slices.template.tooltipY = 40;
    pieSeriesLast.tooltip.label.textAlign = "middle";
    pieSeriesLast.tooltip.background.filters.clear();
    pieSeriesLast.tooltip.background.pointerLength = 0;
    pieSeriesLast.tooltip.background.strokeOpacity = 0;
    pieSeriesLast.tooltip.label.propertyFields.fill = "color";
    pieSeriesLast.tooltip.background.cornerRadius = 50;
    pieSeriesLast.tooltip.label.minWidth = 150;
    pieSeriesLast.tooltip.label.minHeight = 100;
    pieSeriesLast.tooltip.label.textValign = "middle";
    let hsLast = pieSeriesLast.slices.template.states.getKey("hover");
    hsLast.properties.scale = 1.08;
    let asLast = pieSeriesLast.slices.template.states.getKey("active");
    asLast.properties.shiftRadius = .1;
    this.chartLast.data.reverse();
    //LEYENDA
    this.chartLast.legend = new am4charts.Legend();
    this.chartLast.legend.valueLabels.template.text = "";
    this.chartLast.legend.labels.template.fill = am4core.color("#7c7c7c");
    this.chartLast.legend.valueLabels.template.fill = am4core.color("#7c7c7c");
    let markerLast = this.chartLast.legend.markers.template.children.getIndex(0);
    markerLast.cornerRadius(15, 15, 15, 15);
    markerLast.strokeWidth = 2;
    markerLast.strokeOpacity = 1;
    this.chartLast.legend.reverseOrder = true;
    //ANIMACION INICIAL
    pieSeriesLast.hiddenState.properties.opacity = 1;
    pieSeriesLast.hiddenState.properties.endAngle = -90;
    pieSeriesLast.hiddenState.properties.startAngle = -90;

    //BAR CHART
    this.chartBar = am4core.create("barchart-div", am4charts.XYChart);
    if (this.chartBar.logo) {
      this.chartBar.logo.dispose()
    }
    this.chartBar.data = [{
      "date": "",
      "principal": 0,
      "ganancia": 0,
      "ganancia_total": 0,
      "total": 0,
    }];
    //CREATE AXES
    let categoryAxis = this.chartBar.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "date";
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.minGridDistance = 50;
    categoryAxis.animationDuration = 0;

    let axisTooltip = categoryAxis.tooltip;
    axisTooltip.background.fill = am4core.color("#7c7c7c");
    axisTooltip.background.strokeWidth = 0;
    axisTooltip.background.cornerRadius = 5;
    axisTooltip.background.pointerLength = 0;
    axisTooltip.animationDuration = 0;
    axisTooltip.dy = 5;

    //TOTAL
    let categoryAxis2 = this.chartBar.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis2.renderer.opposite = true;
    categoryAxis2.dataFields.category = "date";
    categoryAxis2.renderer.grid.template.disabled = true;
    categoryAxis2.renderer.grid.disabled = true;
    categoryAxis2.renderer.labels.template.disabled = true;
    categoryAxis2.animationDuration = 0;
    categoryAxis2.adapter.add("getTooltipText", () => {
      return "{total}";
    });

    axisTooltip = categoryAxis2.tooltip;
    axisTooltip.background.fill = am4core.color("#7c7c7c");
    axisTooltip.background.strokeWidth = 0;
    axisTooltip.background.cornerRadius = 5;
    axisTooltip.background.pointerLength = 0;
    axisTooltip.animationDuration = 0;
    axisTooltip.dy = 5;

    let valueAxis = this.chartBar.yAxes.push(new am4charts.ValueAxis());
    valueAxis.numberFormatter.numberFormat = "'$'#,###.##";
    valueAxis.tooltip.disabled = true;

    let valueAxis2 = this.chartBar.yAxes.push(new am4charts.ValueAxis());
    valueAxis2.renderer.opposite = true;
    valueAxis2.renderer.grid.template.disabled = true;
    valueAxis2.renderer.labels.template.disabled = true;
    valueAxis2.tooltip.disabled = true;

    //COLORES
    this.chartBar.colors.list = [
      am4core.color("#123B4F"),
      am4core.color("#659F6B"),
      am4core.color("#E6AE3F"),
    ];
    //CREATE SERIES
    let series = this.chartBar.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "principal";
    series.dataFields.categoryX = "date";
    series.name = "Principal";
    series.tooltipText = "[#fff]{name}: [bold, #fff]{valueY}[/]";
    series.tooltip.background.filters.clear();
    series.tooltip.animationDuration = 0;
    series.stacked = true;

    // GANANCIA TOTAL (antes: COTRIBUCIONES)
    let series2 = this.chartBar.series.push(new am4charts.ColumnSeries());
    series2.dataFields.valueY = "ganancia_total";
    series2.dataFields.categoryX = "date";
    series2.name = "Ganancia Total";
    series2.tooltipText = "[#000]{name}: [bold, #000]{valueY}[/]";
    series2.tooltip.background.filters.clear();
    series2.stacked = true;
    series2.columns.template.column.cornerRadiusTopLeft = 5;
    series2.columns.template.column.cornerRadiusTopRight = 5;
    series2.tooltip.animationDuration = 0;

    // GANANCIA (nueva serie)
    let series3 = this.chartBar.series.push(new am4charts.LineSeries());
    series3.dataFields.valueY = "ganancia";
    series3.dataFields.categoryX = "date";
    series3.yAxis = valueAxis2;
    series3.name = "Ganancia";
    series3.strokeWidth = 3;
    series3.tooltipText = "[#000]{name}: [bold, #000]{valueY}[/]";
    series3.strokeWidth = 3;
    series3.tooltip.animationDuration = 0;

    //CURSOR
    this.chartBar.cursor = new am4charts.XYCursor();
    this.chartBar.cursor.behavior = "none";
    this.chartBar.cursor.lineY.disabled = true;
    this.chartBar.cursor.fullWidthLineX = true;
    this.chartBar.cursor.xAxis = categoryAxis;
    this.chartBar.cursor.lineX.strokeOpacity = 0;
    this.chartBar.cursor.lineX.fill = am4core.color("#7c7c7c");
    this.chartBar.cursor.lineX.fillOpacity = 0.1;
    this.chartBar.cursor.animationDuration = 0;
    //LEYENDA
    this.chartBar.legend = new am4charts.Legend();
    this.chartBar.legend.labels.template.fill = am4core.color("#7c7c7c");
    this.chartBar.legend.valueLabels.template.fill = am4core.color("#7c7c7c");
    // BOTON ZOOM-OUT
    this.chartBar.zoomOutButton.align = "left";
    this.chartBar.zoomOutButton.valign = "top";
    this.chartBar.zoomOutButton.background.defaultState.properties.fill = am4core.color("#7c7c7c");
    this.chartBar.zoomOutButton.background.defaultState.properties.fillOpacity = .2;
    this.chartBar.zoomOutButton.background.states.getKey("hover").properties.fill = am4core.color("#7c7c7c");
    this.chartBar.zoomOutButton.background.states.getKey("down").properties.fill = am4core.color("#7c7c7c");
    this.chartBar.zoomOutButton.icon.strokeWidth = 2;

    this.updateChartTheme(this.isDarkMode);

  },
}
</script>
<style>
input {
  /*font-family: 'Montserrat', serif !important;*/
}


.tab-text {
  color: white;
}

.monthly-payment-line {
  width: 40px;
  border-width: 2px !important;
  margin-bottom: 5px !important;
  background-color: rgb(182, 71, 12) !important;
  border-color: rgb(182, 71, 12) !important;
  opacity: initial;
  margin-top: 20px !important;
}

.title-pie {
  margin-bottom: -20px !important;
  /*font-family: 'Montserrat', serif !important;*/
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 2rem;

  padding: 0 !important;
}

table tr:hover {
  background-color: #999 !important;
  color: #fff !important;
}

.v-tooltip span {
  font-size: 17px;
}

.col-style {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

/* 🔹 Fondo transparente */
.v-application,
.v-main,
.v-container {
  background: transparent !important;
}
</style>


<style scoped>

* {
  font-family: 'Montserrat', sans-serif;
}

/* Modo oscuro */
.dark-mode {
  background-color: #121212;
  color: #fff;
}

/* Ajuste de etiquetas */
.dark-mode ::v-deep(.el-input__inner) {
  background-color: transparent !important;
  color: #fff !important;
}

/* Ajuste de select */
.dark-mode ::v-deep(.el-select) {
  background-color: #000 !important;
}

.dark-mode ::v-deep(.el-input) {
  background-color: #000 !important;
  color: #fff !important;
}

/* Resultados */
.result-item {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 18px;
  border-bottom: 1px solid #e0e0e0;
}

.dark-mode .result-item {
  border-bottom: 1px solid #444;
}

.result-label {
  padding-top: 8px !important;
  font-weight: bold;
}

.dark-mode .result-label {
  color: #ccc;
}

.result-value {
  font-weight: bold;
  font-size: 28px;
}

.dark-mode .result-value {
  color: #fff;
}

</style>


<style scoped>

/* 🔹 Fondo transparente */
.v-application,
.v-main,
.v-container {
  background: transparent !important;
}


::v-deep(.v-application) {
  background: transparent !important;
}

::v-deep(.v-main) {
  background: transparent !important;
}

/* 🔹 Textos en gris */
.v-application,
.result-item,
.result-label,
.result-value,
.tab-text,
h1,
h2,
h3,
p,
span {
  color: #7c7c7c !important;
}

/* 🔹 Inputs y selects con texto y bordes en gris */
::v-deep(.v-input__control) {
  background-color: transparent !important;
}

::v-deep(.v-label) {
  color: #808080 !important;
}

/* 🔹 Placeholder en gris */
::v-deep(.v-input input::placeholder) {
  color: #888 !important;
}

/* 🔹 Tablas con bordes y texto en gris */
::v-deep(.v-table) {
  background-color: transparent !important;
  border-color: #666 !important;
}

::v-deep(.v-table thead th),
::v-deep(.v-table tbody td) {
  color: #b0b0b0 !important;
  border-bottom: 1px solid #666 !important;
}

/* 🔹 Cambios en switch (Dark Mode) */
::v-deep(.v-switch .v-input__control) {
  background-color: transparent !important;
  border: 1px solid #666 !important;
}

::v-deep(.v-switch .v-input__control .v-label) {
  color: #b0b0b0 !important;
}

/* 🔹 Botones con bordes y texto en gris */
::v-deep(.v-btn) {
  color: #b0b0b0 !important;
}

/* 🔹 Divider en gris */
.v-divider {
  background-color: #666 !important;
}

/* 🔹 Hover en filas de tablas */
::v-deep(.v-table tbody tr:hover) {
  background: transparent !important;
}

</style>

<style>
.v-text-field__prefix {
  margin-top: 0 !important;
  color: #999999 !important;
  background-color: rgba(187, 187, 187, 0.15) !important;
}
.v-text-field__suffix {
  margin-top: 0 !important;
  color: #999999 !important;
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-text-field .v-field__input {
  background-color: rgba(187, 187, 187, 0.15) !important;
}

.v-text-field .v-field__input,
.v-select .v-field__input {
  background-color: rgba(187, 187, 187, 0.15) !important;
}
</style>

